import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';

import { firebaseStorage } from '@/configs/firebase.config';
import { recordHandledError } from '@/utils/logger.util';

const fileExtension = (name: string): string => {
  const ext = /\.([a-zA-Z0-9]+)$/.exec(name)?.[1];
  return ext ? ext.toLowerCase() : 'bin';
};

/**
 * Uploads a file to Firebase Storage under `folder/` and resolves with its download URL.
 * Mirrors the mobile app's storage service so both write to the same bucket.
 */
export const uploadImage = async (folder: string, file: File): Promise<string> => {
  const unique = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const path = `${folder}/${unique}.${fileExtension(file.name)}`;
  try {
    const storageRef = ref(firebaseStorage, path);
    await uploadBytes(storageRef, file, { contentType: file.type });
    return await getDownloadURL(storageRef);
  } catch (error) {
    // This path touches neither axios nor react-query, so nothing else would ever record it —
    // a Storage rules change or an expired bucket credential would break every admin upload
    // silently. Report, then rethrow so callers keep showing their own message.
    recordHandledError(error, { folder, contentType: file.type, sizeBytes: file.size });
    throw error;
  }
};
